/* eslint-disable max-len */
// Design-system styled native <select>: white field, rule border, brand focus,
// and a custom chevron with breathing room after it (right padding), so the
// arrow is never cramped against the edge.
const SELECT_CHEVRON = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23546077' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")";

export const STYLED_SELECT_CLASS = 'h-10 pl-3 pr-9 border border-rule rounded-[8px] text-sm bg-white text-ink-900 focus:outline-none focus:border-brand-500 cursor-pointer';

export const STYLED_SELECT_STYLE = {
  borderStyle: 'solid',
  WebkitAppearance: 'none',
  MozAppearance: 'none',
  appearance: 'none',
  backgroundImage: SELECT_CHEVRON,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 12px center',
};
